import React, { useState } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
} from 'reactstrap';
import classnames from 'classnames';
import WFHRequest from './WFHRequest';
import { BulletList } from 'react-content-loader';
import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';
import SkeletonWithLoaders from 'components/common/Spinner';


const WFHPage = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState(false);
  const roleId = decryptData(Cookies.get('role_id'));

  const toggleTab = (tab) => {
    console.log(tab, "tab")
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <SkeletonWithLoaders>
      <div
        data-tour="wfh-module"
        style={{ borderRadius: '10px', marginTop: '20px' }}>
        <Card
          className="shadow p-1 bg-white"
          style={{ borderRadius: '10px', marginTop: '80px' }}
        >
          <CardBody>
            <Nav tabs>
              {/* Hide Apply WFH for admin */}
              {!(roleId === 1 || roleId === 2) && (
                <NavItem>
                  <NavLink data-tour="wfh-apply-tab"
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => toggleTab('1')}
                    style={{ cursor: 'pointer', color: 'purple' }}
                  >
                    <i className="bx bx-chat font-size-20 d-sm-none" />
                    <span className="d-none d-sm-block">Apply WFH</span>
                  </NavLink>
                </NavItem>
              )}

              {/* Show WFH Logs for admin */}
              {roleId === 1 || roleId === 2 ? (
                <NavItem>
                  <NavLink data-tour="wfh-logs-tab"
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => toggleTab('1')}
                    style={{ cursor: 'pointer', color: 'purple' }}
                  >
                    <i className="bx bx-group font-size-20 d-sm-none" />
                    <span className="d-none d-sm-block">WFH Logs</span>
                  </NavLink>
                </NavItem>
              ) : null}
            </Nav>
            {loading ? (
              <div>
                <BulletList />
              </div>
            ) : (
              <div>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <WFHRequest activeTab={activeTab} />
                  </TabPane>
                  {/* <TabPane tabId="2">
                  <EmployeeLogs activeTab={activeTab} />
                </TabPane> */}
                </TabContent>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    </SkeletonWithLoaders>
  );
};

export default WFHPage;